import React, { useState, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import ExecuteAxios from "Components/ExecuteAxios/ExecuteAxios";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [authenticated, setAuthenticated] = useState('');

    useEffect(() => {
        validateIam().then(async user => {
            if (!user) {
                setUser(null);
                setAuthenticated(false);
                return;
            }

            setUser({
                id: user.id,
                username: user.username,
                email: user.email,
                name: user.name,
                module: user.module || 'OCMT'
            });
            setAuthenticated(true);
            setLoading(false);
        });
    }, []);

    async function validateIam() {
        try {
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: '/api/perichert/authenticator/iam',
                withCredentials: true
            };
            const authenticatedData = await axios.request(config);

            if (authenticatedData && authenticatedData.data && authenticatedData.data.email) {
                const parameters = {
                    email: authenticatedData.data.email.replace(/\s/g, "")
                }
                return await ExecuteAxios.api('get', `/user/get-user-by-email`, { params: parameters })
            } else return null;
        } catch (error) {
            setLoading(false);
        }
    }

    const login = async (email, password) => {
        try {
            let data = JSON.stringify({
                email: email,
                password: password
            });

            let config = {
                method: 'post',
                maxBodyLength: Infinity,
                url: '/api/perichert/authenticator/login',
                data: data,
                headers: {
                    'Content-Type': 'application/json'
                }
            };

            await axios.request(config);
            const user = await validateIam();

            if (user) {

                setUser({
                    id: user.id,
                    username: user.username,
                    email: user.email,
                    name: user.name,
                    module: user.module || 'OCMT'
                });
                setAuthenticated(true);

            } else {
                setUser(null);
                setAuthenticated(false);
            }

            navigate('/services')
        } catch (error) {
            setUser(null);
            setAuthenticated(false);
        }
    };

    const logout = async () => {
        await axios.post('/api/perichert/authenticator/logout');
        setUser(null);
        setAuthenticated(false);
        navigate("/");
    };

    return (
        <AuthContext.Provider
            value={{ authenticated, user, loading, login, logout }}>
            {children}
        </AuthContext.Provider >
    );

};